<div class="modal-header">
  <h2 class="modal-title" mat-dialog-title>
    <span *ngIf="data.config" trans>Update spotify widget</span>
    <span *ngIf="!data.config">Add spotify widget</span>
  </h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<form (ngSubmit)="createOrUpdate()" [formGroup]="form" ngNativeValidate>
  <div mat-dialog-content>
    <div class="input-container">
      <label for="spotify-widget-url" trans>Spotify Url</label>
      <input
        type="url"
        id="spotify-widget-url"
        formControlName="url"
        placeholder="https://open.spotify.com/track/2sqfLwGKXDw1nGjFhH3GGX?si=f329040f45804ec5"
        cdkFocusInitial
        required
      />
      <div class="error" *ngIf="(errors$ | async).url as error" trans>{{ error }}</div>
    </div>
  </div>

  <div class="buttons right" mat-dialog-actions>
    <button (click)="close()" type="button" mat-button class="button cancel cancel-button" trans>
      Cancel
    </button>
    <button
      type="submit"
      mat-raised-button
      color="accent"
      [disabled]="editor.loading$ | async"
      class="button primary submit-button"
    >
      <span *ngIf="data.config" trans>Update</span>
      <span *ngIf="!data.config" trans>Add</span>
    </button>
  </div>
</form>
